import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "components/ui";
import { ReadMore } from "components/atoms";

const UserBasicInfo = ({ uInfo }) => {
  return (
    <div>
      <Card className="min-w-full">
        <CardHeader>
          <CardTitle>Basic Information</CardTitle>
        </CardHeader>
        <CardContent className="kt-scrollable-x-auto pb-3 p-0">
          <Table className="align-middle text-sm text-muted-foreground">
            <TableBody>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Bio
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right break-all">
                  <ReadMore comment={uInfo?.bio ?? "N/A"} maxChar={40} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Nationality
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.country?.name ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Culture
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.culture?.name ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Section (optional)
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.section?.name ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Age
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.age ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Height
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.height ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Employment
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.employment?.name ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Gender
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right capitalize">
                  {uInfo?.gender ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Marital Status
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.marital_status ?? "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-28 text-secondary-foreground font-normal text-left">
                  Have kids
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {uInfo?.is_have_kids === true ? "Yes" : "No"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserBasicInfo;
